import { useStaticQuery, graphql } from 'gatsby'

const useGatsbyImagesQuery = () =>
  useStaticQuery(graphql`
    query GatsbyImageQuery {
      allImageSharp {
        nodes {
          fluid(maxWidth: 10080, quality: 100, webpQuality: 100) {
            originalName
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `).allImageSharp.nodes

export default useGatsbyImagesQuery
